(() => {
  if (window.__infoStoreAssistanceTrackingBooted) return;
  window.__infoStoreAssistanceTrackingBooted = true;

  const GA4_PATTERN = /^G-[A-Z0-9]+$/;
  const ADS_PATTERN = /^AW-\d+\/[A-Za-z0-9_-]+$/;
  const ALLOWED_POSITIONS = new Set(['hero', 'problem', 'process', 'visit', 'floating']);
  const tagState = {
    loaderReady: false,
    configuredIds: new Set(),
    analyticsAllowed: false,
    marketingAllowed: false,
  };

  const gtag = (...args) => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag(...args);
  };

  const readConfig = (root) => ({
    enabled: root.dataset.assistanceLeadTrackingEnabled === 'true',
    ga4: GA4_PATTERN.test(root.dataset.ga4MeasurementId || '') ? root.dataset.ga4MeasurementId : '',
    ads: [...new Set([
      root.dataset.googleAdsAssistancePrimary,
      root.dataset.googleAdsAssistanceSecondary,
    ].filter((value) => ADS_PATTERN.test(value || '')))],
  });

  const ensureGoogleTag = (loaderId) => {
    if (tagState.loaderReady || !loaderId) return;
    tagState.loaderReady = true;

    gtag('consent', 'default', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(loaderId)}`;
    document.head.appendChild(script);
    gtag('js', new Date());
  };

  const configureAllowedDestinations = (config) => {
    const adsIds = config.ads.map((value) => value.split('/')[0]);
    const allowedIds = [
      ...(tagState.analyticsAllowed && config.ga4 ? [config.ga4] : []),
      ...(tagState.marketingAllowed ? adsIds : []),
    ];

    if (!allowedIds.length) return;
    ensureGoogleTag(allowedIds[0]);

    [...new Set(allowedIds)].forEach((id) => {
      if (tagState.configuredIds.has(id)) return;
      tagState.configuredIds.add(id);
      gtag('config', id, { send_page_view: false });
    });
  };

  const syncConsent = (config) => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;

    tagState.analyticsAllowed = privacy.analyticsProcessingAllowed();
    tagState.marketingAllowed = privacy.marketingAllowed();

    if (tagState.analyticsAllowed || tagState.marketingAllowed) {
      ensureGoogleTag(config.ga4 || config.ads[0]?.split('/')[0]);
      gtag('consent', 'update', {
        analytics_storage: tagState.analyticsAllowed ? 'granted' : 'denied',
        ad_storage: tagState.marketingAllowed ? 'granted' : 'denied',
        ad_user_data: tagState.marketingAllowed ? 'granted' : 'denied',
        ad_personalization: tagState.marketingAllowed ? 'granted' : 'denied',
      });
      configureAllowedDestinations(config);
    } else if (tagState.loaderReady) {
      gtag('consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
      });
    }
  };

  const publishLead = (config, position) => {
    if (!ALLOWED_POSITIONS.has(position)) return;

    const payload = {
      lead_type: 'assistencia_tecnica',
      contact_method: 'whatsapp',
      cta_position: position,
      page_path: window.location.pathname,
    };

    try {
      window.Shopify?.analytics?.publish?.('infostore_assistance_lead', payload);
    } catch (_) {
      // A telemetria nunca deve impedir a abertura do WhatsApp.
    }

    try {
      if (tagState.analyticsAllowed && config.ga4) {
        gtag('event', 'generate_lead', { ...payload, send_to: config.ga4 });
      }
      if (tagState.marketingAllowed) {
        config.ads.forEach((destination) => gtag('event', 'conversion', { send_to: destination }));
      }
    } catch (_) {
      // Falha segura: o link continua com seu comportamento nativo.
    }
  };

  const init = (root) => {
    if (root.dataset.trackingReady === 'true') return;
    root.dataset.trackingReady = 'true';

    const config = readConfig(root);
    if (!config.enabled) return;

    if (window.Shopify?.customerPrivacy) syncConsent(config);
    window.Shopify?.loadFeatures?.(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => { if (!error) syncConsent(config); },
    );
    document.addEventListener('visitorConsentCollected', () => syncConsent(config));

    root.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('[data-assistance-lead-position]');
      if (!link || !root.contains(link)) return;
      publishLead(config, link.dataset.assistanceLeadPosition);
    });
  };

  document.querySelectorAll('[data-assistance-section]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches('[data-assistance-section]')
      ? event.target
      : event.target.querySelector('[data-assistance-section]');
    if (root) init(root);
  });
})();
